import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "HRKRIReportingAnalytics" })((_theme, toCompare) => ({
  page: {
    margin: "20px",
  },
  HRKRICardResponsive: {
    width: toCompare ? "48%" : "100%",
    [`@media (max-width:1060px)`]: {
      width: "100%",
    },
  },
  HRKRIExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop:  "-30px",
  },
  SaveBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop: "10px",
  },
}));
